import { ClassNames } from '@emotion/react';
import React from 'react';
import Youtube from 'react-youtube';

type Props = {
  videoId: string;
};

export const YoutubeVideo = ({ videoId }: Props) => {
  return (
    <ClassNames>
      {({ css }) => (
        <Youtube
          videoId={videoId}
          containerClassName={css`
            position: relative;
            width: 100%;
            height: 0;
            padding-bottom: 56.25%;
            overflow: hidden;
            margin-bottom: 50px;

            > iframe {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
            }
          `}
        />
      )}
    </ClassNames>
  );
};
